/*
  NINI termekcimke-forditasok - a tema a "__label:xyz" termek-tagek szoveget irja ki a
  termekkartyakra (.label--custom), a tagek pedig nem forditahatok. Ez a script a NINI
  fejlec "Cimke-forditasok" beallitasabol kapott, az aktualis nyelvre ervenyes terkep
  (#nini-label-map) alapjan csereli a feliratokat - a kesobb betoltott listakban is
  (szures, fejlec-lenyilo, ajanlok). A tema fajljait nem modositja.
  Keszitette: Akos | branch: dev/akos | 2026-09-28
*/

(() => {
  let map = null;
  try {
    const element = document.getElementById('nini-label-map');
    map = element ? JSON.parse(element.textContent) : null;
  } catch (error) {
    map = null;
  }
  if (!map || Object.keys(map).length === 0) return;

  const SELECTOR = '.label--custom, .label--custom2';

  const translate = (label) => {
    if (label.dataset.niniLabel) return;
    const key = label.textContent.trim().toLowerCase();
    if (Object.prototype.hasOwnProperty.call(map, key)) {
      label.dataset.niniLabel = key;
      label.textContent = map[key];
    }
  };

  const translateWithin = (root) => {
    if (root.matches && root.matches(SELECTOR)) translate(root);
    if (root.querySelectorAll) root.querySelectorAll(SELECTOR).forEach(translate);
  };

  const start = () => {
    translateWithin(document);

    // AJAX-szal betoltott termeklistak (szures, lapozas, lenyilok, ajanlok).
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) translateWithin(node);
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
